import { animate, useReducedMotion } from "framer-motion";
import { useEffect, useState } from "react";
type Props = {
  to: number;
  decimals?: number;
  duration?: number;
  delay?: number;
  className?: string;
};

/** Counts up and decelerates naturally into its final value. */
export function CountUp({
  to,
  decimals = 1,
  duration = 2,
  delay = 0,
  className
}: Props) {
  const reduced = useReducedMotion();
  const [value, setValue] = useState(reduced ? to : 0);
  useEffect(() => {
    if (reduced) {
      setValue(to);
      return;
    }
    const controls = animate(0, to, {
      duration,
      delay,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: setValue
    });
    return () => controls.stop();
  }, [to, duration, delay, reduced]);
  return <span className={`tabular ${className ?? ""}`} aria-label={to.toFixed(decimals)} data-id="element-175" data-mp="1g6b30sofoo87">
      {value.toFixed(decimals)}
    </span>;
}